import { ChainId } from '@ssap/contract-helpers';
import { rgba, useThemeContext } from 'ssap-ui-kit';
import classNames from 'classnames';
import React from 'react';
import { getNetworkConfig } from '../../../helpers/config/markets-and-network-config';
import staticStyles from './style';

interface MarketSelectButtonProps {
  onClick: () => void;
  logo: string;
  subLogo?: string;
  logoText?: string;
  className?: string;
  disabled?: boolean;
  active?: boolean;
  hoverColored?: boolean;
  chainId: ChainId;
  isDark?: boolean;
}

export default function MarketSelectButton({
  onClick,
  logo,
  subLogo,
  logoText,
  className,
  disabled,
  active,
  hoverColored,
  chainId,
  isDark,
}: MarketSelectButtonProps) {
  const { currentTheme } = useThemeContext();
  const config = getNetworkConfig(chainId);

  const hoverColor = rgba(`${currentTheme.primary.rgb}, 0.7`);
  const testnetMark = config.isFork
    ? 'F'
    : config.isTestnet
    ? 'T' // ? config.name.charAt(0).toUpperCase()
    : undefined;

  return (
    <button
      onClick={onClick}
      className={classNames('MarketSelectButton', className, {
        MarketSelectButton__active: active,
        MarketSelectButton__hoverColored: hoverColored,
        MarketSelectButton__dark: isDark,
      })}
      type="button"
      disabled={disabled}
    >
      {(disabled || active) && <span className="MarketSelectButton__border" />}

      <div className="MarketSelectButton__inner">
        <div className="MarketSelectButton__innerLeft">
          <div className="MarketSelectButton__logo-inner">
            <img src={logo} alt="" />
            {!!logoText && !subLogo && <span>{logoText}</span>}
          </div>

          {/* <GradientText
            className="MarketSelectButton__marketText"
            colorStart={currentTheme.white.rgb}
            colorEnd={currentTheme.white.rgb}
            title={intl.formatMessage(messages.market)}
          /> */}
        </div>

        {subLogo && <img className="MarketSelectButton__subLogo" src={subLogo} alt="" />}
      </div>

      {testnetMark && <span className="MarketSelectButton__kovan">{testnetMark}</span>}

      <style jsx={true} global={true}>
        {staticStyles}
      </style>
      <style jsx={true}>{`
        .MarketSelectButton {
          &:hover {
            .MarketSelectButton__inner {
              box-shadow: 0 1px 8px 0 #04adf5;
            }
          }
          &.MarketSelectButton__active,
          &:disabled {
            .MarketSelectButton__inner {
              // border: 1px solid #04adf5 !important;
            }
          }

          &__logo-inner {
            color: ${currentTheme.darkBlue.hex};
          }

          &__inner {
            background: ${currentTheme.primary.hex};
          }

          &.MarketSelectButton__hoverColored {
            &:hover {
              .MarketSelectButton__inner {
                border-color: ${hoverColor};
                box-shadow: 0 1px 8px 0 ${hoverColor};
              }
            }
          }

          &__border {
            background: linear-gradient(180deg, #00f6a7 0%, #04f5ee 100%);
          }

          &__dark {
            &.MarketSelectButton__active,
            &:disabled {
              .MarketSelectButton__inner {
                border: 2px solid ${currentTheme.white.hex} !important;
              }
            }

            .MarketSelectButton__inner {
              background: ${currentTheme.darkBlue.hex};
            }
            .MarketSelectButton__logo-inner {
              color: ${currentTheme.white.hex};
            }
            .MarketSelectButton__border {
              background: ${currentTheme.white.hex};
            }
          }
        }
      `}</style>
    </button>
  );
}
